<template>
    <div class="navbar navbar-dark bg-dark justify-content-center align-items-start" v-if="visible">
        <div class="col-md-4 py-3 px-4" style="position: relative;">
            <!-- //nie dziala na urzadzeniach mobilnych w wirtualna klawiatura 
                        <input id="searchCallInput" type="text" v-model="callInput" placeholder="CALLSIGN" -->
            <!-- @blur="selectCall(callInput)" -->
            <input @keyup="(e) => inputKeyDown(e)" @focus="searchCallInputFocus = true" id="searchCallInput" type="text"
                v-bind:value="callInput" v-on:input="callInput = $event.target.value" :placeholder="t('CALLSIGN')"
                class="form-control rounded text-uppercase" autocomplete="off"/>

            <div v-if="fetchResult.length && searchCallInputFocus == true" ref="refSelectCall" style="z-index: 999; position: absolute;">
                <div class="rounded mt-2">
                    <div class="list-group" id="list-tab" role="tablist">
                        <a v-for="item, itemKey in fetchResult" :key="item"
                            class="list-group-item list-group-item-action" data-bs-toggle="list"
                            @click="selectCall(item.callsignssid, formatedRT(item.reporttime))"
                            :class="{ 'active': itemKey === arrowCounter }">
                            <i :class="getAPRSSymbolImageClass(item.icon, 24)"></i>{{ item.callsignssid }}
                            <span class="ms-3 text-info">{{ fromNowDDiffD(item.reporttime) }} d</span>
                        </a>
                    </div>
                </div>
            </div>

        </div>

        <div class="col-md-2 py-3 px-4">
            <Datepicker v-model="datePicked" class="form-control rounded text-uppercase"
                @focus="searchCallInputFocus = false" />
        </div>

        <div class="col-md-1 py-3 px-4 text-end">
            <button type="button" class="btn btn-outline-light" @click="searchButton()">{{ t('search') }}</button>
        </div>
    </div>
</template>


<script setup>

import { ref, watch, computed, defineEmits, defineExpose } from 'vue'
import { useI18n } from 'vue-i18n'
import { format } from 'date-fns'
import {getAPRSSymbolImageClass} from '../js/aprssymbols.js'
import {fromNowDDiffD} from '../js/tmlf.js'
import Datepicker from 'vue3-datepicker'

const { t } = useI18n()

const emits = defineEmits(['emitCallsignDate'])

defineExpose({
  setCallInput,
});

//TEMPLATE
const datePicked = ref(new Date())
const callInput = ref('')
//====================================

const API_URL = 'https://aprsdb.tomul.net:45443/json/posits-cs.php?od=0&okres=0&all=1&callsign='

const arrowCounter = ref(0)
const refSelectCall = ref(null)
const fetchResult = ref([])
const selectedCall = ref('')
const fetching = ref(false)
const searchCallInputFocus = ref(false)
const visible = ref(true)

watch(callInput, async () => {
    fetchResult.value = []
    if ((`${callInput.value.length}` > 2) && (callInput.value != selectedCall.value)) {
        selectedCall.value = null
        fetchData()
    }
})

// watch(datePicked, async () => {
//     selectedDate.value = formatedPickedDate.value
// })

const selectCall = (call,date) => {
    call = call.toUpperCase()
    if ((call.length < 10) && (call.length > 0)) {
        // console.log("selectCall: " + call)
        selectedCall.value = call
        callInput.value = call
        datePicked.value = new Date(date)
        fetchResult.value = []
    } else {
        fetchResult.value = []
    }
}

function setCallInput (call,v,date) {
    visible.value = v
    callInput.value = call
    if (date) {
        datePicked.value = new Date(date)
    }
}

function searchButton() {
    if (callInput.value.length) {
        selectCall(callInput.value, formatedPickedDate.value)
        // selectedDate.value = formatedPickedDate.value
        visible.value = false
        emits('emitCallsignDate', callInput.value, formatedPickedDate.value)
    }
}

function inputKeyDown(e) {
    if ((e) && (fetchResult.value.length)) {
        refSelectCall.value.focus()
        if (e.key === 'ArrowDown') {
            arrowCounter.value < fetchResult.value.length - 1 ? arrowCounter.value = arrowCounter.value + 1 : arrowCounter.value = fetchResult.value.length - 1
        }
        if (e.key === 'ArrowUp') {
            arrowCounter.value > 0 ? arrowCounter.value = arrowCounter.value - 1 : arrowCounter.value = 0
        }
        if (e.key === 'Enter') {
            selectCall(fetchResult.value[arrowCounter.value].callsignssid,formatedRT(fetchResult.value[arrowCounter.value].reporttime))
        }
    }

}

async function fetchData() {
    fetching.value = true
    arrowCounter.value = 0
    try {
        let searchCall = callInput.value
        const url = `${API_URL}${callInput.value.toUpperCase()}`
        await (await fetch(url)).json().then(result => {
            fetching.value = false
            if (searchCall == callInput.value) {
                if (result) {
                    fetchResult.value = result
                } else {
                    fetchResult.value = []
                }
            }
        })
    } catch (error) {
        fetching.value = false
        fetchResult.value = ['Error! Could not reach the API. ' + error]
    }
}

const formatedPickedDate = computed(() => format(new Date(datePicked.value), 'yyyy-MM-dd'))

function formatedRT(reporttime) {
    let res = format(new Date(reporttime), 'yyyy-MM-dd')
    return res
}

</script>


<style scoped>
@import "../css/aprs-symbols.css";

a {
    display: inline-flex;
}

i {
    margin-right: 6px;
    width: 24px;
    height: 25px;
}

</style>

<i18n>
    {
      "pl": {
        "search": "Szukaj",
        "CALLSIGN": "Znak Stacji"
      }
    }
</i18n>
